module.exports = new __parcel__URL__("Priestskill_13.c7f15e2a.png").toString();